<div fxLayout='column' fxFill [dir]="cService.selectedLanguage?.isRtl ? 'rtl' : 'ltr'">
  <!-- Header -->
  <mat-progress-bar
    [class.hidden]='cService.hideIndeterminateProgress'
    mode='indeterminate'
    class='fixed extreme-tl'
    color='accent'
  ></mat-progress-bar>

  <div [style.background-color]="'#' + cService.userProfile.HqColour" style='color: white; padding: 0 15px'>
    <div fxLayout='row' style='height: 45px; margin-top: 10px; opacity: 0.8'>
      <div mat-dialog-title class='margin-none force' fxFlex>
        <img class='suggested-action-icon' [src]="cService.imageRoot + 'insights/suggested-action.svg'" />
        &nbsp; {{ cService.readyTranslations.generic.suggestedAction }}
      </div>

      <button
        mat-icon
        mat-dialog-close
        style='top: -10px; right: -15px'
        [style.backgroundColor]="'#' + cService.userProfile.HqColour"
        class='close-button'
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Body -->
  <div fxFlex fxLayout='column'>
    <div fxLayout='row' class='stat-and-suggestion-cards'>
      <div fxLayout='column' fxFlex='40'>
        <div class='title-offset'></div>
        <insight-action-card
          fxFlex
          *ngIf='profileInsightDetails && profileInsightDetails.detail'
          [iconPath]="cService.imageRoot + 'insights/driving.svg'"
          [cardHeadline]='profileInsightDetails?.detail?.insight'
          [miniFooterCards]='usesMobileWhileDriving'
        ></insight-action-card>
      </div>

      <!-- eDriving suggestions -->
      <div fxFlex='60' class='edriving-suggests'>
        <div class='title'>{{ 'eDriving Suggests' | uppercase }}</div>
        <div fxLayout='row'>
          <insight-action-card
            fxFlex
            *ngIf='profileInsightDetails && profileInsightDetails.riskCoach'
            [cardThumbnailPath]='profileInsightDetails?.riskCoach?.image'
            cardHeadline='RiskCOACH: {{ profileInsightDetails?.riskCoach?.name }}'
            cardSubHeadline='{{ profileInsightDetails?.riskCoach?.subTitle }}'
            subHeadlineColor='#777777'
            cardBodyText='{{ profileInsightDetails?.riskCoach?.summary }}'
          ></insight-action-card>

          <insight-action-card
            fxFlex
            *ngIf='profileInsightDetails && profileInsightDetails.pdf'
            [cardThumbnailPath]='profileInsightDetails?.pdf?.image'
            cardHeadline='{{ cService.readyTranslations.generic.bestPracticeGuide }} : {{
							profileInsightDetails?.pdf?.name
						}}'
            cardSubHeadline='{{ profileInsightDetails?.pdf?.subTitle }}'
            subHeadlineColor='#777777'
            cardBodyText='{{ profileInsightDetails?.pdf?.summary }}'
            actionText="{{
							cService.userProfile.userPermissions.permProfileInsightsSendPdfs ===
							cService.permLevels.FALSE
								? ''
								: cService.readyTranslations.generic.sendPdfToAtRiskDrivers
						}}"
            (actionEvent)='sendPdfs()'
          ></insight-action-card>
        </div>
      </div>
    </div>

    <div fxLayout='column' fxFlex class='driver-report-container'>
      <div class='driver-report-title'>
        {{ cService.readyTranslations.generic.atRiskDrivers }}
      </div>
      <vrm-casual-report
        fxFlex
        *ngIf='driverReportMeta'
        [metadata]='driverReportMeta'
        [rawData]='profileInsightDetails.drivers'
        [otherOptions]="{ reportHeight: '100%' }"
      >
      </vrm-casual-report>
    </div>
  </div>
</div>
